import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/main.scss";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import ru from "vee-validate/dist/locale/ru";
import VueCookies from "vue-cookies";

import {
  MatIcon,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  ImageBox
} from "@/components";

import i18n from "./i18n";

Vue.component("MatIcon", MatIcon);
Vue.component("Card", Card);
Vue.component("CardHeader", CardHeader);
Vue.component("CardContent", CardContent);
Vue.component("CardFooter", CardFooter);
Vue.component("ImageBox", ImageBox);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend("fio", {
  validate: (value) => {
      return /^(?!-)(?!\s)(?!.*--)(?!.* {2,})(?!.*- )(?!.* -)(?!.*'')(?!.*'-)(?!.*-')(?!.* ')(?!.*' )[a-zA-Zа-яА-ЯёЁ'-\s]*$/i.test(value);
  },
  message: "The {_field_} field may only contain alphabetic characters, hyphen, space or apostrophe"
});
extend("phone", {
  validate: (value) => {
    return /^(\+\d|\d)( |-|)\d{3}( |-|)\d{0,3}( |-|)\d{0,4}$/g.test(value);
  },
  message: "Телефонный номер имеет ошибочный формат",
});

localize("ru", ru);

Vue.config.productionTip = false;
Vue.use(VueCookies); 

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
